import { render } from "./share_forms_with_lead.html?vue&type=template&id=788b8a55&external"
import script from "./share_forms_with_lead.js?vue&type=script&lang=js&external"
export * from "./share_forms_with_lead.js?vue&type=script&lang=js&external"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__